(function(){
  if (window.__ssInit) return; window.__ssInit = true;
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce && 'IntersectionObserver' in window) root.classList.add('ss-js');

  function initReveal(scope){
    var els = (scope || document).querySelectorAll('.ss-rv:not(.is-in)');
    if (!root.classList.contains('ss-js')) { els.forEach(function(e){ e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    els.forEach(function(e){ io.observe(e); });
  }

  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function initCountdowns(scope){
    (scope || document).querySelectorAll('[data-ss-countdown]').forEach(function(el){
      if (el.__ss) return; el.__ss = true;
      var end = Date.parse(el.getAttribute('data-ss-countdown'));
      if (isNaN(end)) { el.style.display = 'none'; return; }
      var n = { d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'), m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]') };
      function tick(){
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) { el.style.display = 'none'; clearInterval(t); return; }
        n.d.textContent = pad(Math.floor(left / 86400));
        n.h.textContent = pad(Math.floor(left % 86400 / 3600));
        n.m.textContent = pad(Math.floor(left % 3600 / 60));
        n.s.textContent = pad(left % 60);
      }
      var t = setInterval(tick, 1000); tick();
    });
  }

  function initGallery(scope){
    (scope || document).querySelectorAll('[data-ss-gallery]').forEach(function(g){
      var main = g.querySelector('[data-ss-main] img');
      g.querySelectorAll('[data-ss-thumb]').forEach(function(b){
        b.addEventListener('click', function(){
          if (main) { main.src = b.getAttribute('data-ss-thumb'); main.removeAttribute('srcset'); }
          g.querySelectorAll('[data-ss-thumb]').forEach(function(x){ x.classList.remove('is-on'); });
          b.classList.add('is-on');
        });
      });
    });
  }

  function addItems(items, btn, errEl){
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var drawer = document.querySelector('cart-drawer');
    var payload = { items: items };
    if (drawer && typeof drawer.renderContents === 'function') {
      payload.sections = ['cart-drawer', 'cart-icon-bubble'];
      payload.sections_url = window.location.pathname;
    }
    var req = items.length
      ? fetch(rootUrl + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) })
      : fetch(rootUrl + '?sections=cart-drawer,cart-icon-bubble');
    return req
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return items.length ? j : { sections: j }; }); })
      .then(function(res){
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        if (drawer && res && res.sections) {
          drawer.classList.remove('is-empty');
          if (items[0]) res.id = items[0].id;
          drawer.renderContents(res);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } else {
          window.location.href = rootUrl + 'cart';
        }
      })
      .catch(function(e){
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        if (errEl) { errEl.textContent = (e && (e.description || e.message)) || 'Sorry, something went wrong. Please try again.'; errEl.style.display = 'block'; }
      });
  }

  function initBuy(scope){
    (scope || document).querySelectorAll('form.ss-buy-form').forEach(function(form){
      if (form.__ss) return; form.__ss = true;
      form.addEventListener('submit', function(ev){
        ev.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var errEl = form.querySelector('.ss-buy__err');
        var gift = form.querySelector('[data-ss-gift-check]');
        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        // Send the whole form so app data (e.g. Kaching bundle quantity/properties) goes with it
        var fd = new FormData(form);
        if (!fd.get('quantity')) fd.set('quantity', '1');
        if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
        fetch(rootUrl + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
          .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
          .then(function(){
            if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
            if (gift && gift.checked && gift.value) return addItems([{ id: Number(gift.value), quantity: 1 }], btn, errEl);
            return addItems([], btn, errEl);
          })
          .catch(function(e){
            if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
            if (errEl) { errEl.textContent = (e && (e.description || e.message)) || 'Sorry, something went wrong. Please try again.'; errEl.style.display = 'block'; }
          });
      });
    });
    (scope || document).querySelectorAll('form.ss-quick-add').forEach(function(form){
      if (form.__ss) return; form.__ss = true;
      form.addEventListener('submit', function(ev){
        ev.preventDefault();
        addItems([{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }], form.querySelector('[type="submit"]'), null);
      });
    });
    (scope || document).querySelectorAll('[data-ss-addboth]').forEach(function(btn){
      if (btn.__ss) return; btn.__ss = true;
      btn.addEventListener('click', function(ev){
        ev.preventDefault();
        var ids = (btn.getAttribute('data-ss-addboth') || '').split(',').filter(Boolean);
        addItems(ids.map(function(id){ return { id: Number(id), quantity: 1 }; }), btn, btn.parentNode.querySelector('.ss-buy__err'));
      });
    });
  }

  function initSticky(){
    var bar = document.querySelector('[data-ss-sticky]');
    var buy = document.getElementById('ss-buy');
    if (!bar || !buy || !('IntersectionObserver' in window)) return;
    var pastTop = false, buyVisible = false;
    function upd(){ bar.classList.toggle('is-on', pastTop && !buyVisible); }
    new IntersectionObserver(function(e){ buyVisible = e[0].isIntersecting; upd(); }).observe(buy);
    window.addEventListener('scroll', function(){ pastTop = window.scrollY > 500; upd(); }, { passive: true });
  }

  function smoothAnchors(){
    document.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('.ss a[href^="#"]');
      if (!a || a.hasAttribute('data-ss-addboth')) return;
      var t = document.querySelector(a.getAttribute('href'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
    });
  }

  // Kaching Bundles: if its widget was injected outside our buy box (app-embed fallback), move it above ADD TO CART
  function placeKaching(){
    var f = document.querySelector('form.ss-buy-form');
    if (!f || f.querySelector('div.kaching-bundles')) return true;
    var els = document.querySelectorAll('div.kaching-bundles');
    for (var i = 0; i < els.length; i++) {
      if (!f.contains(els[i]) && !els[i].parentElement.closest('.kaching-bundles')) {
        f.insertBefore(els[i], f.querySelector('[type="submit"]'));
        var q = f.querySelectorAll('input[type="hidden"][name="quantity"]');
        if (q.length > 1) q[0].remove();
        return true;
      }
    }
    return false;
  }
  function watchKaching(){
    if (placeKaching() || !('MutationObserver' in window)) return;
    var mo = new MutationObserver(function(){ if (placeKaching()) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function(){ mo.disconnect(); }, 20000);
  }

  function all(scope){ initReveal(scope); initCountdowns(scope); initGallery(scope); initBuy(scope); }
  function boot(){ all(); initSticky(); smoothAnchors(); watchKaching(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function(e){ all(e.target); });
})();
